import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SESSION_EXPIRY_HOLD_MAX_MS } from 'config'
import { formatSecondsLeft } from './SessionCountdown.utils'
import {
  Header,
  TimeLeft,
  TimeLeftBar,
  Title,
} from './SessionEndCountdown.style'

const SECONDS_UNTIL_END = SESSION_EXPIRY_HOLD_MAX_MS / 1000

interface SessionEndCountdownProps {
  secondsLeft: number
}

// Time left to sign in again once the session has expired, shown in the
// warning of the session extension dialog
const SessionEndCountdown = ({ secondsLeft }: SessionEndCountdownProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Header>
        <Title>{t('sessionEndCountdown.title')}</Title>
        <TimeLeft role="timer">{formatSecondsLeft(secondsLeft)}</TimeLeft>
      </Header>
      <Typography variant="body2">
        {t('sessionEndCountdown.message')}
      </Typography>
      <Typography variant="body2" fontWeight={600} mt={0.5}>
        {t('sessionEndCountdown.leaveInfo')}
      </Typography>
      <TimeLeftBar
        variant="determinate"
        color="warning"
        value={(secondsLeft / SECONDS_UNTIL_END) * 100}
      />
    </>
  )
}

export default SessionEndCountdown
